export const BASE_URL =
  import.meta.env.MODE === "development" ? "" : import.meta.env.VITE_SERVER_URL;

export const TAGS = {
  DOSESPOT_PATIENT: "DOSESPOT_PATIENT",
  PATIENT_TEXT_MESSAGES: "PatientTextMessages",
  EXPERIMENT_RESULTS: "ExperimentResults",
  EXPERIMENT_VARIANTS: "ExperimentVariants",
  EXPERIMENTS: "Experiments",
  SUBSCRIPTION_REACTIVATION: "SubscriptionReactivation",
  INTAKE_QUESTION_OPTIONS: "IntakeQuestionOptions",
  QUESTION_OPTIONS: "QuestionOptions",
  PROVIDERS: "Providers",
  STATES: "States",
  TASKS: "Tasks",
  PATIENT: "Patient",
  PATIENTS: "Patients",
  PATIENT_ADDRESS: "PatientAddress",
  MESSAGE_THREADS: "MessageThreads",
  MESSAGES: "Messages",
  TASK: "Task",
  PRESCRIPTION: "Prescription",
  PRESCRIPTIONS: "Prescriptions",
  PRESCRIPTION_DETAILS: "PrescriptionDetails",
  ORDERS: "Orders",
  BUCKET: "Bucket",
  CLINICAL_NOTES: "ClinicalNotes",
  ONLINE_VISITS: "OnlineVisits",
  ONLINE_VISIT: "OnlineVisit",
  NEXT_TASK: "NextTask",
  NEXT_WAITING_ROOM_PATIENT: "NextWaitingRoomPatient",
  FILE_STORAGE: "FileStorage",
  PROMO_BANNERS: "PromoBanners",
  COUPONS: "Coupons",
  PRODUCT_COUPONS: "ProductCoupons",
  PRODUCTS: "Products",
  PRODUCT: "Product",
  PRODUCT_PRICES: "ProductPrices",
  PRODUCT_PRICE: "ProductPrice",
  PRODUCT_INTAKES: "ProductIntakes",
  INTAKE_QUESTIONS: "IntakeQuestions",
  INTAKE_QUESTION: "IntakeQuestion",
  INTAKES: "Intakes",
  COUPON_REDEMPTIONS: "CouponRedemptions",
  PATIENT_SUBSCRIPTIONS: "PatientSubscriptions",
  INVOICES: "Invoices",
  PROFILES: "Profiles",
  WAITING_ROOMS: "WaitingRooms",
  PATIENT_WEIGHTS: "PatientWeights",
  MEDICATIONS: "Medications",
  PHARMACIES: "Pharmacies",
  PHARMACY_STATES: "PharmacyStates",
  PRODUCT_MEDICATIONS: "ProductMedications",
  PRODUCT_TITRATION: "ProductTitration",
  TASK_FOR_RESOURCE: "TaskForResource",
  PHARMACY: "Pharmacy",
  PAYMENT_METHODS: "PaymentMethods",
  ONE_TIME_PRODUCTS: "OneTimeProducts",
  DAYS_SUPPLY: "DaysSupply",
  PATIENT_COUPONS: "PatientCoupons",
  PRODUCT_VARIANTS: "ProductVariants",
  EMPLOYEES: "Employees",
  EMPLOYEE: "Employee",
  EMPLOYEE_ROLES: "EmployeeRoles",
  PROVIDER_LICENSES: "ProviderLicenses",
  PROVIDER_SPECIALTIES: "ProviderSpecialties",
  PHARMACY_PROVIDERS: "PharamcyProviders",
  ROLES: "Roles",
  MEDICATION_STRENGTHS: "MedicationStrengths",
  MEDICATION: "Medication",
  QUESTIONS: "Questions",
  MEDICATION_TITRATIONS: "MedicationTitrations",
  PRODUCT_CATEGORIES: "ProductCategories",
  TREATMENTS: "Treatments",
  DISPUTES: "Disputes",
  E_PRESCRIBE: "EPrescribe",
  PATIENT_PREFERRED_PHARMACY: "PatientPreferredPharmacy",
  E_PRESCRIBE_PHARMACIES: "EPrescribePharmacies",
  E_PRESCRIBE_PRIOR_AUTHS: "EPrescribePriorAuths",
  PRIOR_AUTHORIZATION: "PriorAuthorization",
  PAYMENTS_INFORMATION: "PaymentsInformation",
  TITRATION: "Titration",
  PATIENT_RATINGS: "PatientRatings",
  CONVERSATION_THREADS: "ConversationThreads",
  PROVIDER_AVAILABILITY: "ProviderAvailability",
  TIME_SLOTS: "TimeSlots",
};
